import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../assets/images/lang-ar.svg'
import _imports_1 from './../assets/images/lang-en.svg'
import _imports_2 from './../assets/images/theme-light.svg'
import _imports_3 from './../assets/images/theme-dark.svg'


const _withScopeId = n => (_pushScopeId("data-v-903352d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-navbar" }
const _hoisted_2 = { class: "nav-header" }
const _hoisted_3 = { class: "logo-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "nav-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-btn" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "nav-check" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      id: "nav-check",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checked) = $event))
    }, null, 512), [
      [_vModelCheckbox, _ctx.checked]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", { src: _ctx.imgLogo }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('general.projectName')), 1)
    ]),
    _hoisted_6,
    _createElementVNode("div", {
      class: "nav-links",
      id: "nav-links",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clicked()))
    }, [
      _createVNode(_component_router_link, { to: { name: 'Home' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('navbar.Home')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'Services' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('navbar.ServicesProjects')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'Clients' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('navbar.ClientsAndPartners')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'About' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('navbar.AboutUs')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'ContactUs' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('navbar.ContactUs')), 1)
        ]),
        _: 1
      }),
      (_ctx.language == _ctx.LANGUAGES.enUS)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setAppLanguage(_ctx.LANGUAGES.arEG))),
            class: "icon"
          }, _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.language == _ctx.LANGUAGES.arEG)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setAppLanguage(_ctx.LANGUAGES.enUS))),
            class: "icon"
          }, _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.theme == _ctx.THEMES.dark)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAppTheme(_ctx.THEMES.light))),
            class: "icon-theme"
          }, _hoisted_12))
        : _createCommentVNode("", true),
      (_ctx.theme == _ctx.THEMES.light)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAppTheme(_ctx.THEMES.dark))),
            class: "icon-theme"
          }, _hoisted_14))
        : _createCommentVNode("", true)
    ])
  ]))
}